<div
  class="pr-4 relative shadow-none text-cobalt-500 flex items-center justify-between w-full mb-6"
  *ngxPermissionsOnly="Permission.TICKETING_WRITE"
>
  <!-- CLICKABLE AREA -->
  <div
    #helpCtaRoot
    class="flex items-center relative flex-nowrap md:basis-full md:flex-wrap pl-2 cursor-pointer"
    (click)="toggleBlimp()"
  >
    <div
      class="bg-[url('/assets/images/img_user_nitel@2x.png')] bg-contain bg-no-repeat bg-center w-10 h-10 mr-2"
    ></div>

    <div class="flex flex-row-reverse items-start text-lg md:text-xl">
      Have a question?
    </div>

    <div class="relative -mt-2 ml-1">
      <mat-icon
        class="!w-4 !h-4 text-blue-500"
        svgIcon="question-mark"
      ></mat-icon>

      <div
        #helpBlimpView
        class="absolute top-8 left-1/2 -translate-x-1/2 bg-blue-950 text-white text-center rounded-lg shadow-[0_2px_8px_rgba(0,0,0,.1)] z-10 opacity-0 transition-opacity duration-200 ease-in-out w-64 px-4 py-2 block"
        [ngClass]="(showBlimp$ | async) ? 'opacity-95 z-20' : ''"
      >
        <div class="arrow-up w-4 h-2 mx-auto -mt-4 mb-1"></div>
        <h3 class="font-semibold text-sm">Need Help?</h3>
        <p class="font-normal text-[13px]">
          Create a ticket with the subject “Billing” and we&apos;ll take it from
          there!
        </p>
      </div>
    </div>
  </div>

  @if (hasInvoice) {
    <ng-container *ngxPermissionsOnly="Permission.TICKETING_WRITE">
      <button class="primary-button" (click)="onCreateTicket()">
        Create Ticket
      </button>
    </ng-container>
  }
</div>
